import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BaseUrl from "./Baseurl/Api.js";

const LoginRegister = () => {
  const [showLogin, setShowLogin] = useState(true);

  // Login States
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");

  // Register States
  const [regName, setRegName] = useState("");
  const [regEmail, setRegEmail] = useState("");
  const [regPassword, setRegPassword] = useState("");
  const [regConfirmPassword, setRegConfirmPassword] = useState("");

  const { loading } = useSelector((state) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn === "true") {
      navigate("/dashboard");
    }
  }, [navigate]);

  const showLoading = (message = "Please wait...") => {
    Swal.fire({
      title: message,
      didOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
  };

  // Handle Login
  const handleLogin = async () => {
    if (!loginEmail || !loginPassword) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter both email and password!",
      });
      return;
    }

    try {
      showLoading("Logging in...");

      const response = await BaseUrl.get(`/api/get_usersdata/${loginEmail}`);
      Swal.close(); // Close loading

      const result = response.data;

      if (!result.status || result.status !== "success") {
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: result.message || "Invalid email or password",
        });
        return;
      }

      const userData = result.user?.[0];
      if (!userData) {
        Swal.fire({
          icon: "error",
          title: "User Not Found",
          text: "No account found with this email",
        });
        return;
      }

      const { id, email, name, profile_photo_url } = userData;

      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("userId", id);
      localStorage.setItem("email", email);
      localStorage.setItem("name", name);
      localStorage.setItem("image", profile_photo_url);

      Swal.fire({
        icon: "success",
        title: "Login Successful",
        text: `Welcome back, ${name}!`,
        timer: 1500,
        showConfirmButton: false,
      });

      setLoginEmail("");
      setLoginPassword("");
      setTimeout(() => navigate("/"), 1500);
    } catch (error) {
      Swal.close();
      console.error("Login Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong! Please try again.",
      });
    }
  };

  // Handle Registration
  const handleRegister = async () => {
    if (!regName || !regEmail || !regPassword || !regConfirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "All fields are required!",
      });
      return;
    }

    if (regPassword !== regConfirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Password Mismatch",
        text: "Passwords do not match!",
      });
      return;
    }

    try {
      showLoading("Registering...");

      const response = await BaseUrl.post("/api/get_user", {
        name: regName,
        email: regEmail,
        password: regPassword,
      });

      Swal.close();
      const result = await response.data;

      if (result.success) {
        Swal.fire({
          icon: "success",
          title: "Registration Successful",
          text: "You can now log in!",
          timer: 1500,
          showConfirmButton: false,
        });

        setRegName("");
        setRegEmail("");
        setRegPassword("");
        setRegConfirmPassword("");

        setTimeout(() => navigate("/"), 1500);
      } else {
          Swal.fire({
          icon: "success",
          title: "Registration Successful",
          text: "You can now log in!",
          timer: 1500,
          showConfirmButton: false,
        });
     setTimeout(() => navigate("/dashboard"), 1500);
      }
    } catch (error) {
      Swal.close();
      console.error("Registration Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong! Please try again.",
      });
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "150px",
        minHeight: "70vh",
        background: "#fff",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <div
        style={{
          width: "400px",
          background: "#fff",
          padding: "32px",
          borderRadius: "8px",
          border: "1px solid #e5e7eb",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginBottom: "20px",
            color: "#30b348ff",
          }}
        >
          {showLogin ? "Login" : "Create account"}
        </h2>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            marginBottom: "20px",
          }}
        >
          <button style={{ ...styles.socialBtn, background: "#3b5998" }}>f</button>
          <button style={{ ...styles.socialBtn, background: "#db4437" }}>G</button>
          <button style={{ ...styles.socialBtn, background: "#1da1f2" }}>X</button>
        </div>

        {showLogin ? (
          <>
            <input
              type="email"
              placeholder="Email"
              value={loginEmail}
              onChange={(e) => setLoginEmail(e.target.value)}
              style={styles.input}
            />
            <input
              type="password"
              placeholder="Password"
              value={loginPassword}
              onChange={(e) => setLoginPassword(e.target.value)}
              style={styles.input}
            />
            <p
              style={{
                fontSize: "13px",
                color: "#065f46",
                cursor: "pointer",
                marginTop: "4px",
              }}
            >
              Forgot your password?
            </p>
            <button onClick={handleLogin} style={styles.button}>
              {loading ? "Loading..." : "Sign in"}
            </button>
          </>
        ) : (
          <>
            <input
              type="text"
              placeholder="First name"
              value={regName}
              onChange={(e) => setRegName(e.target.value)}
              style={styles.input}
            />
            <input
              type="email"
              placeholder="Email"
              value={regEmail}
              onChange={(e) => setRegEmail(e.target.value)}
              style={styles.input}
            />
            <input
              type="password"
              placeholder="Password"
              value={regPassword}
              onChange={(e) => setRegPassword(e.target.value)}
              style={styles.input}
            />
            <input
              type="password"
              placeholder="Confirm Password"
              value={regConfirmPassword}
              onChange={(e) => setRegConfirmPassword(e.target.value)}
              style={styles.input}
            />
            <button onClick={handleRegister} style={styles.button}>
              {loading ? "Loading..." : "Create"}
            </button>
          </>
        )}

        <p
          onClick={() => setShowLogin(!showLogin)}
          style={{
            marginTop: "16px",
            color: "#065f46",
            fontWeight: "500",
            fontSize: "14px",
            cursor: "pointer",
          }}
        >
          {showLogin ? "Create account" : "Already have an account? Sign in"}
        </p>
      </div>
    </div>
  );
};

const styles = {
  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "14px",
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    fontSize: "15px",
    fontFamily: "'Inter', sans-serif",
  },
  button: {
    width: "100%",
    padding: "12px",
    background: "#30b348ff",
    color: "#fff",
    fontWeight: "600",
    fontSize: "15px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "0.3s",
  },
  socialBtn: {
    width: "38px",
    height: "38px",
    borderRadius: "4px",
    color: "#fff",
    fontSize: "16px",
    border: "none",
    cursor: "pointer",
  },
};

export default LoginRegister;
